import { getAccessToken } from "../contexts/UserAPIContext"; // ou ../contexts/UserAPIContext se quiser deixar lá
import { getApiUrl } from "../config/api";

export const authFetch = async (endpoint, options = {}) => {
  const token = await getAccessToken();

  const customHeaders = options.headers || {};

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
    ...customHeaders,
  };

  if (headers["Content-Type"] === null) {
    delete headers["Content-Type"];
  }

  return fetch(getApiUrl(endpoint), {
    ...options,
    headers,
  });
};
